/**
 * Tiny indirection so the in-world scene can ask the boot flow to return to the
 * character-selection screen (switch character) without a circular import between
 * `main.ts` and `WorldScene.ts`.
 */
let handler: (() => void) | null = null;

export function onRequestSelection(fn: () => void): void {
  handler = fn;
}

/** Tear down the world and go back to character selection. */
export function requestSelection(): void {
  handler?.();
}
